import useObjectSearchParams from 'hooks/useObjectSearchParams';
import useSetDeleteURLParams from 'hooks/useSetDeleteURLParams';

interface UserCertificatesFilterParams {
  search: string;
  onlyExpired: boolean;
  tagIds: string;
}

const useUserCertificatesFilters = () => {
  const { search, onlyExpired, tagIds } =
    useObjectSearchParams<UserCertificatesFilterParams>();

  const { setURLParam, deleteURLParam } =
    useSetDeleteURLParams<UserCertificatesFilterParams>();

  return { search, onlyExpired, tagIds, setURLParam, deleteURLParam };
};

export default useUserCertificatesFilters;
